import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { colors, radius, shadows } from '../styles/theme';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8001';

/**
 * İK özet kartı — Yönetim ve Muhasebe dashboardlarında kullanılır.
 * Bu ayın personel gider özeti + lokasyon bazlı kırılım + sağlık uyarıları.
 */
const IkDashboardWidget = () => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [saglik, setSaglik] = useState(null);

  useEffect(() => {
    const headers = { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` };
    fetch(`${API_URL}/api/ik/dashboard`, { headers }).then(r => r.ok ? r.json() : null).then(setData);
    fetch(`${API_URL}/api/ik/saglik`, { headers }).then(r => r.ok ? r.json() : null).then(setSaglik);
  }, []);

  const fmt = (n) => (n || 0).toLocaleString('tr-TR', { maximumFractionDigits: 0 });

  if (!data) return null;

  return (
    <div style={{ background: colors.surface, padding: 18, borderRadius: radius.md, boxShadow: shadows.sm, cursor: 'pointer' }} onClick={() => navigate('/ik')}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 10 }}>
        <h4 style={{ margin: 0, fontSize: 14 }}>👥 Personel Giderleri</h4>
        <span style={{ fontSize: 11, color: '#888' }}>{data.ay?.slice(0, 7) || ''}</span>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 10 }}>
        <div>
          <div style={{ fontSize: 11, color: '#666' }}>Toplam</div>
          <div style={{ fontSize: 20, fontWeight: 700, color: '#1565c0' }}>{fmt(data.toplam_brut)} ₺</div>
        </div>
        <div>
          <div style={{ fontSize: 11, color: '#666' }}>Aktif Personel</div>
          <div style={{ fontSize: 20, fontWeight: 700 }}>{data.aktif_personel}</div>
        </div>
      </div>

      <div style={{ fontSize: 12, color: '#555', lineHeight: 1.7 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span>Bankadan</span><strong>{fmt(data.bankadan)} ₺</strong>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span>Elden</span><strong style={{ color: '#2e7d32' }}>{fmt(data.elden)} ₺</strong>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 4 }}>
          <span>Puantaj Durumu</span>
          <span style={{ fontSize: 11 }}>
            <span style={{ color: '#e65100' }}>{data.taslak_sayisi}T</span> · <span style={{ color: '#1565c0' }}>{data.kapanan_sayisi}K</span> · <span style={{ color: '#2e7d32' }}>{data.odenen_sayisi}Ö</span>
          </span>
        </div>
      </div>

      {saglik && saglik.uyari_sayisi > 0 && (
        <div style={{ marginTop: 10, padding: 8, background: '#fff3e0', borderLeft: '3px solid #e65100', fontSize: 11, color: '#e65100' }}>
          ⚠ {saglik.uyari_sayisi} sağlık uyarısı: {saglik.uyarilar.map(u => u.tip).join(', ')}
        </div>
      )}
    </div>
  );
};

export default IkDashboardWidget;
